import { Component } from '@angular/core';

@Component({
  selector: 'app-rtk-base-analyzer-page',
  templateUrl: './rtk-base-analyzer.component.html'
})
export class RtkBaseAnalyzerPageComponent {}


